import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import OrderGenieV3ProductSearch from './OrderXV3ProductSearch';

const OrderGenieProductSearch = () => {
  const navigate = useNavigate();

  return (
    <div className="order-genie-product-search-page">
      <div className="page-header d-flex align-items-center gap-3 px-4 py-3 border-bottom bg-white">
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft size={15} />
          <span>Back</span>
        </button>
        <div>
          <h5 className="mb-0 fw-semibold">Product Search</h5>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0" style={{ fontSize: '0.78rem' }}>
              <li className="breadcrumb-item text-muted">OrderX</li>
              <li className="breadcrumb-item active">Product Search</li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="p-4">
        <OrderGenieV3ProductSearch />
      </div>
    </div>
  );
};

export default OrderGenieProductSearch;
